import { Component, inject, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { SuccessComponent } from "../success/success.component";
import { Dialog } from "@angular/cdk/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { serviceStatus } from 'src/app/core/utils/tab.util';

interface TimeSlot {
  from_timing: string;
  to_timing: string;
  id: string;
  position: number;
}

@Component({
  selector: "app-reschedule-modal",
  template: ` <div class="modal-container">
    <!-- Modal Card -->
    <div class="modal-content">
      <p class="text-lg font-bold mb-4">Are you sure want to Assign the service back to admin?</p>

      <form [formGroup]="rescheduleForm" (ngSubmit)="onReschedule()">
        <!-- Select comment-->
        <div class="mb-4">
          <textarea
            id="reason"
            type="text"
            placeholder="Reason for assiging back to admin"
            formControlName="reason"
            class="w-full border border-gray-300 rounded px-3 py-2"
            required
          ></textarea>
        </div>

        <!-- Radio Buttons -->
        <div class="mb-4">
          <p class="text-lg text-pink-500 font-bold mb-4">New visit timing</p>
          <div class="flex space-x-4">
            <label class="flex items-center">
              <input type="radio" formControlName="availability" value="available" class="mr-2">
              Available
            </label>
            <label class="flex items-center">
              <input type="radio" formControlName="availability" value="not_available" class="mr-2">
              Not Available
            </label>
          </div>
        </div>

        <!-- Date and Time Selection (shown when Available is selected) -->
        <div *ngIf="rescheduleForm.get('availability')?.value === 'available'" class="space-y-4 mb-4">
          <div formArrayName="slots">
            <!-- First Slot -->
            <div class="border p-4 rounded mb-4">
              <h3 class="font-bold mb-4">First Slot</h3>
              <div [formGroupName]="0" class="space-y-4">
                <div>
                  <label class="block mb-2 font-medium">Date: <span class="text-red-500">*</span> <span class="text-sm text-red-500">(Mandatory)</span></label>
                  <input type="date" formControlName="date" (change)="onDateSelected($event, 0)" class="w-full border border-gray-300 rounded px-3 py-2">
                </div>
                <div>
                  <label class="block mb-2 font-medium">Time Slot: <span class="text-red-500">*</span> <span class="text-sm text-red-500">(Mandatory)</span></label>
                  <select formControlName="timeSlot" (change)="onTimeSlotSelected($event, 0)" class="w-full border border-gray-300 rounded px-3 py-2">
                    <option value="">Select time slot</option>
                    <option *ngFor="let slot of availableSlots[0]" [value]="slot.id">
                      {{slot.from_timing}} - {{slot.to_timing}}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Second Slot -->
            <div class="border p-4 rounded">
              <h3 class="font-bold mb-4">Second Slot</h3>
              <div [formGroupName]="1" class="space-y-4">
                <div>
                  <label class="block mb-2 font-medium">Date:</label>
                  <input type="date" formControlName="date" (change)="onDateSelected($event, 1)" class="w-full border border-gray-300 rounded px-3 py-2">
                </div>
                <div>
                  <label class="block mb-2 font-medium">Time Slot:</label>
                  <select formControlName="timeSlot" (change)="onTimeSlotSelected($event, 1)" class="w-full border border-gray-300 rounded px-3 py-2">
                    <option value="">Select time slot</option>
                    <option *ngFor="let slot of availableSlots[1]" [value]="slot.id">
                      {{slot.from_timing}} - {{slot.to_timing}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="text-red-500 mb-4">Note - Rescheduling service will assign the service back to admin.</p>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-2">
          <button
            type="button"
            (click)="onClose()"
            class="w-full sm:w-auto bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded"
          >
            Close
          </button>
          <button
            [disabled]="!rescheduleForm.valid"
            class="w-full sm:w-auto bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded
            disabled:bg-gray-200 disabled:cursor-not-allowed"
            type="submit"
          >
            Reschedule
          </button>
        </div>
      </form>
    </div>
  </div>`,
  styles: [`
    :host {
      display: block;
      height: 100%;
    }

    .modal-container {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding: 1rem;
      overflow-y: auto;
      z-index: 1000;
    }

    .modal-content {
      background: white;
      border-radius: 0.5rem;
      padding: 1.5rem;
      width: 100%;
      max-width: 32rem;
      margin: 2rem auto;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    }

    @media (max-width: 640px) {
      .modal-container {
        padding: 0;
      }

      .modal-content {
        margin: 0;
        min-height: 100vh;
        border-radius: 0;
      }
    }

    /* Ensure inputs are properly sized on mobile */
    input[type="date"],
    select {
      min-height: 2.5rem;
    }

    /* Improve touch targets on mobile */
    @media (max-width: 640px) {
      button {
        min-height: 3rem;
      }
    }
  `]
})
export class RescheduleModalComponent {
  serviceStatus:any = serviceStatus;
  baseUrl = environment.url;
  token: any;
  private snackBar = inject(MatSnackBar);
  rescheduleForm: FormGroup;
  availableSlots: TimeSlot[][] = [[], []];

  constructor(
    private router: Router,
    private http: HttpClient,
    private dialog: Dialog,
    private dialogRef: MatDialogRef<RescheduleModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.rescheduleForm = this.fb.group({
      availability: ['', Validators.required],
      slots: this.fb.array([
        this.fb.group({
          date: [''],
          timeSlot: [''],
          start_time: [''],
          end_time: ['']
        }),
        this.fb.group({
          date: [''],
          timeSlot: [''],
          start_time: [''],
          end_time: ['']
        })
      ]),
      reason: ['', Validators.required]
    });

    // Add custom validation for slots when available is selected
    this.rescheduleForm.get('availability')?.valueChanges.subscribe(value => {
      const slotsArray = this.rescheduleForm.get('slots') as FormArray;
      const firstSlot = slotsArray.at(0);
      
      if (value === 'available') {
        firstSlot.get('date')?.setValidators([Validators.required]);
        firstSlot.get('timeSlot')?.setValidators([Validators.required]);
        firstSlot.get('start_time')?.setValidators([Validators.required]);
        firstSlot.get('end_time')?.setValidators([Validators.required]);
      } else {
        firstSlot.get('date')?.clearValidators();
        firstSlot.get('timeSlot')?.clearValidators();
        firstSlot.get('start_time')?.clearValidators();
        firstSlot.get('end_time')?.clearValidators();
        // Clear the values when not available is selected
        firstSlot.patchValue({
          date: '',
          timeSlot: '',
          start_time: '',
          end_time: ''
        });
      }
      
      firstSlot.get('date')?.updateValueAndValidity();
      firstSlot.get('timeSlot')?.updateValueAndValidity();
      firstSlot.get('start_time')?.updateValueAndValidity();
      firstSlot.get('end_time')?.updateValueAndValidity();
    });
  }

  ngOnInit() {
    this.token = localStorage.getItem("token");
  }

  onDateSelected(event: any, slotIndex: number) {
    const date = event.target.value;
    if (date) {
      this.fetchAvailableSlots(date, slotIndex);
    }
  }

  onTimeSlotSelected(event: any, slotIndex: number) {
    const slotId = event.target.value;
    const selectedSlot = this.availableSlots[slotIndex].find(slot => slot.id === slotId);
    if (selectedSlot) {
      const slotGroup = (this.rescheduleForm.get('slots') as FormArray).at(slotIndex);
      slotGroup.patchValue({
        start_time: selectedSlot.from_timing,
        end_time: selectedSlot.to_timing
      });
    }
  }

  fetchAvailableSlots(date: string, slotIndex: number) {
    const storedCity = localStorage.getItem('selectedCity');
    const cityIdentifier = storedCity ? JSON.parse(storedCity) : 'BLR';
    this.http.get(`${this.baseUrl}/get-all-slots-by-date?validity_date=${date}&city_identifier=${cityIdentifier}`, {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.token}`,
        'Content-Type': 'application/json'
      })
    }).subscribe({
      next: (response: any) => {
        if (response.success && response.data.length > 0) {
          // Get the first item's customer_slots
          this.availableSlots[slotIndex] = response.data[0].customer_slots;
        } else {
          this.availableSlots[slotIndex] = [];
          this.snackBar.open('No slots available for selected date', '', { duration: 3000 });
        }
      },
      error: (err) => {
        this.availableSlots[slotIndex] = [];
        this.snackBar.open(err.error.error || 'Error fetching slots', '', { duration: 3000 });
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onReschedule(): void {
    const formValue = this.rescheduleForm.value;
    let payload: any = {
      id: this.data.id,
      reason_for_rescheduling: formValue.reason
    };

    if (formValue.availability === 'available') {
      const slots = formValue.slots
        .filter((slot: any) => slot.date && slot.start_time && slot.end_time)
        .map((slot: any) => ({
          date: slot.date,
          start_time: slot.start_time,
          end_time: slot.end_time
        }));
      payload.slots = slots;
    }

    this.http.patch(`${this.baseUrl}/reschedule-request`, payload, {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${this.token}`,
        'Content-Type': 'application/json'
      })
    }).subscribe({
      next: (res: any) => {
        console.log("Service confirmed:", res);
        if (res['success']) {
          this.dialogRef.close();
          this.dialog.open(SuccessComponent);
        }
      },
      error: (err) => {
        if (err.error.errors) {
          this.snackBar.open(err.error.errors, '', { duration: 3000 });
        } else {
          this.snackBar.open(err.error.error, '', { duration: 3000 });
        }
        console.error("Error confirming service:", err);
      },
    });
  }
}
